export interface AboutEntry {

  title: string;
  description: string;
  status: boolean;
}

export class AboutEntryImpl implements AboutEntry{

  title: string;
  description: string;
  status = false;


  constructor(title: string, description: string) {
    this.title = title;
    this.description = description;
  }
}
